<template>
  <DropdownField
    inputId="transact-vendor-number"
    name="keystore.vendor_number"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.transactVendorNumber')"
    :placeholder="
      t('sites.singleSite.financialConfig.mealPlans.form.transactVendorNumberPlaceholder')
    "
    :options="[118, 555, 3600]"
    :disabled="!editMealPlan"
    :required="editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
